module.exports = __webpack_public_path__ + "static/media/payments-invert.0b6d02c6.svg";